"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.crypto = void 0;
const crypto_1 = require("./crypto");
exports.crypto = crypto_1.default;
